(function () {
  'use strict';

  const BTA_DEBUG = false;

  function debugLog(...args) {
    if (!BTA_DEBUG) return;
    console.log('[BTA-ACCORDION]', ...args);
  }

  function ensureDebugPanel() {
    if (!BTA_DEBUG) return null;
    let panel = document.getElementById('bta-accordion-debug-panel');
    if (panel) return panel;

    panel = document.createElement('div');
    panel.id = 'bta-accordion-debug-panel';
    panel.style.cssText = [
      'position:fixed',
      'right:10px',
      'bottom:10px',
      'z-index:999999',
      'background:rgba(0,0,0,0.8)',
      'color:#0f0',
      'font-size:11px',
      'font-family:monospace',
      'padding:8px 10px',
      'border-radius:4px',
      'max-width:260px',
      'pointer-events:none',
      'white-space:pre-line',
    ].join(';');
    document.body.appendChild(panel);
    return panel;
  }

  const STYLE_ID = 'bta-accordion-styles';
  let cardCycleIndex = 0;
  let _btaCurrentSelectedCard = null;

  const DESIRED_ORDER = [
    'personalized deluxe decor',
    'costume touches',
    'ballons & backdrops',
    'food add ons',
    'sweets',
    'entertainment',
    'photos and videos',
  ];

  function getCardOrderIndex(card) {
    const title =
      card.querySelector('.bta-accordion-header__title')?.textContent?.trim().toLowerCase() ||
      card.querySelector('.bta-addon-title')?.textContent?.trim().toLowerCase() ||
      '';
    const idx = DESIRED_ORDER.findIndex(t => title.includes(t) || t.includes(title));
    return idx === -1 ? DESIRED_ORDER.length : idx;
  }

  function sortCards() {
    const carousel = document.querySelector('.bta-product-addons-carousel');
    if (!carousel) return;
    const cards = Array.from(carousel.querySelectorAll(':scope > .bta-product-addons-modal__addon-card'));
    if (cards.length <= 1) return;
    cards.sort((a, b) => getCardOrderIndex(a) - getCardOrderIndex(b));
    cards.forEach(card => carousel.appendChild(card));
    debugLog('Cards sorted:', cards.map(c => c.querySelector('.bta-accordion-header__title')?.textContent?.trim()));
  }
  let _btaCurrentSelectedPrice = null;

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const css = `
      .bta-product-addons-modal__content-wrapper {
        padding: 0 !important;
        background-color: #F7F0DF !important;
        overflow-y: auto !important;
        overflow-x: hidden !important;
        flex: 1 1 auto !important;
        min-height: 0 !important;
        height: auto !important;
        max-height: none !important;
      }

      .bta-product-addons-carousel-container {
        display: block !important;
        width: 100% !important;
      }

      .bta-carousel-nav { display: none !important; }

      .bta-product-addons-carousel {
        display: flex !important;
        flex-direction: column !important;
        gap: 0 !important;
        padding: 16px 24px 24px !important;
        width: 100% !important;
        box-sizing: border-box !important;
      }

      .bta-product-addons-modal__addon-card {
        width: 100% !important;
        background-color: transparent !important;
        border: none !important;
        box-shadow: none !important;
        display: flex !important;
        flex-direction: column !important;
        text-align: left !important;
        overflow: visible !important;
        margin-bottom: 10px !important;
        border-radius: 12px !important;
      }

      .bta-product-addons-modal__addon-card:hover {
        transform: none !important;
        box-shadow: none !important;
        transition: none !important;
      }

      .bta-accordion-header {
        display: flex !important;
        align-items: center !important;
        justify-content: space-between !important;
        padding: 16px 20px !important;
        background-color: #B9582E !important;
        cursor: pointer !important;
        user-select: none !important;
        border-radius: 12px !important;
        transition: background-color 0.2s ease !important;
      }

      .bta-accordion-header:hover { background-color: #a34a24 !important; }

      .bta-accordion-header.is-open {
        border-radius: 12px 12px 0 0 !important;
        background-color: #9c4520 !important;
      }

      .bta-accordion-subtitle {
        font-size: 12px !important;
        color: rgba(255,255,255,0.75) !important;
        margin: 0 0 10px !important;
        font-style: italic !important;
        letter-spacing: 0.02em !important;
      }

      .bta-accordion-header__title {
        font-size: 17px !important;
        font-weight: 700 !important;
        color: #fff !important;
        margin: 0 !important;
        letter-spacing: 0.01em !important;
        font-family: Georgia, 'Times New Roman', serif !important;
        font-style: italic !important;
      }

      .bta-accordion-header__chevron {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 28px !important;
        height: 28px !important;
        background-color: rgba(255,255,255,0.15) !important;
        border-radius: 50% !important;
        flex-shrink: 0 !important;
        transition: transform 0.3s ease, background-color 0.2s !important;
        color: #fff !important;
        font-size: 14px !important;
      }

      .bta-accordion-header.is-open .bta-accordion-header__chevron {
        transform: rotate(180deg) !important;
        background-color: rgba(255,255,255,0.25) !important;
      }

      .bta-accordion-body {
        display: none !important;
        background-color: #B9582E !important;
        border-radius: 0 0 12px 12px !important;
        opacity: 0 !important;
        transform: translateY(-4px) !important;
        transition: opacity 0.22s ease, transform 0.22s ease !important;
      }

      .bta-accordion-body.is-open {
        display: block !important;
        opacity: 1 !important;
        transform: translateY(0) !important;
      }

      .bta-accordion-body__inner {
        padding: 15px !important;
        display: flex !important;
        flex-direction: column !important;
        gap: 8px !important;
      }

      .bta-card-middle-content { display: none !important; }
      .bta-card-bottom-content { display: none !important; }

      .bta-variant-carousel {
        display: flex !important;
        flex-direction: column !important;
        gap: 8px !important;
      }

      .bta-variant-nav { display: none !important; }

      .bta-variant-slide {
        width: 100% !important;
        padding: 11px 14px !important;
        border: 1.5px solid rgba(255,255,255,0.3) !important;
        border-radius: 8px !important;
        background-color: #F7F0DF !important;
        font-size: 13px !important;
        cursor: pointer !important;
        color: #B9582E !important;
        display: flex !important;
        flex-direction: row !important;
        justify-content: space-between !important;
        align-items: center !important;
        white-space: normal !important;
        height: auto !important;
        min-height: 44px !important;
        box-sizing: border-box !important;
        transition: background-color 0.15s, border-color 0.15s !important;
        gap: 10px !important;
      }

      .bta-variant-slide:hover {
        background-color: #fff !important;
        border-color: rgba(255,255,255,0.7) !important;
      }

      .bta-variant-slide.is-selected .bta-variant-name {
        color: #8a3e1e !important;
        font-weight: 400 !important;
      }

      .bta-variant-slide.is-selected .bta-variant-price {
        color: #B9582E !important;
      }

      .bta-variant-slide.is-selected {
        background-color: #F7F0DF !important;
        border-color: rgba(255,255,255,0.3) !important;
        font-weight: 400 !important;
        box-shadow: none !important;
      }

      /* Wrapper propio para cada slide */
      .bta-slide-wrapper {
        border-radius: 8px !important;
        transition: box-shadow 0.18s ease !important;
      }

      .bta-slide-wrapper--selected {
        box-shadow: 0 0 0 3px #68876E !important;
        border-radius: 8px !important;
      }

      /* Slides informativos (mismo estilo que variant-slide, sin selección) */
      .bta-info-slide {
        width: 100% !important;
        padding: 11px 14px !important;
        border: 1.5px solid rgba(255,255,255,0.3) !important;
        border-radius: 8px !important;
        background-color: #F7F0DF !important;
        font-size: 13px !important;
        color: #8a3e1e !important;
        display: flex !important;
        align-items: center !important;
        gap: 10px !important;
        box-sizing: border-box !important;
        pointer-events: none !important;
        min-height: 44px !important;
      }

      .bta-info-slide::before {
        display: none !important;
      }

      .bta-variant-name {
        flex: 1 !important;
        pointer-events: none !important;
        color: #8a3e1e !important;
        font-size: 13px !important;
      }

      .bta-variant-price {
        font-size: 13px !important;
        font-weight: 700 !important;
        color: #B9582E !important;
        white-space: nowrap !important;
        pointer-events: none !important;
      }

      .bta-accordion-cart-row {
        display: none !important;
      }

      .bta-accordion-price-label {
        font-size: 16px !important;
        font-weight: 700 !important;
        color: #fff !important;
        min-width: 70px !important;
      }

      .bta-accordion-price-label { display: none !important; }
      .bta-quantity-selector { display: none !important; }
      .bta-error-message-container { display: none !important; }

      .bta-quantity-input {
        width: 32px !important;
        height: 32px !important;
        text-align: center !important;
        border: none !important;
        padding: 0 !important;
        font-size: 14px !important;
        font-weight: 600 !important;
        background-color: transparent !important;
        color: #fff !important;
      }

      .bta-quantity-btn {
        background-color: transparent !important;
        border: none !important;
        color: #fff !important;
        width: 28px !important;
        height: 32px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        cursor: pointer !important;
        font-size: 18px !important;
        opacity: 0.85 !important;
      }

      .bta-quantity-btn:hover {
        opacity: 1 !important;
        background-color: rgba(255,255,255,0.15) !important;
      }

      .bta-add-to-cart-btn {
        background: #68876E !important;
        border: none !important;
        border-radius: 6px !important;
        color: #fff !important;
        cursor: pointer !important;
        font-size: 13px !important;
        font-weight: 600 !important;
        height: 32px !important;
        flex-grow: 1 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        transition: background-color 0.2s !important;
        letter-spacing: 0.02em !important;
      }

      .bta-add-to-cart-btn:hover { background-color: #55715a !important; }

      .bta-error-message {
        color: #ffe0d0 !important;
        font-size: 11px !important;
        margin: 4px 0 0 !important;
      }

      .bta-product-addons-modal__container {
        max-width: 520px !important;
        max-height: calc(100vh - 40px) !important;
        height: auto !important;
        display: flex !important;
        flex-direction: column !important;
        overflow: hidden !important;
      }

      .bta-product-addons-modal__content-wrapper::-webkit-scrollbar { width: 6px; }
      .bta-product-addons-modal__content-wrapper::-webkit-scrollbar-track { background: #ede5cf; border-radius: 3px; }
      .bta-product-addons-modal__content-wrapper::-webkit-scrollbar-thumb { background: #c97a50; border-radius: 3px; }

      .bta-product-addons-modal__header {
        background-color: #F7F0DF !important;
        border-bottom: 2px solid #e0d5be !important;
        flex-shrink: 0 !important;
      }

      .bta-product-addons-modal__title {
        font-family: Georgia, 'Times New Roman', serif !important;
        font-style: italic !important;
        font-size: 22px !important;
        color: #B9582E !important;
      }

      .bta-product-addons-modal__footer {
        background-color: #F7F0DF !important;
        border-top: 2px solid #e0d5be !important;
        flex-shrink: 0 !important;
      }

      .bta-product-addons-modal__continue {
        background: #B9582E !important;
        border-radius: 8px !important;
        padding: 12px 32px !important;
        font-size: 15px !important;
        font-weight: 700 !important;
        letter-spacing: 0.03em !important;
        transition: background-color 0.2s !important;
      }

      .bta-product-addons-modal__continue:hover { background: #a34a24 !important; }

      .bta-product-addons-modal__continue { display: none !important; }

      .bta-footer-wrapper {
        display: flex !important;
        flex-direction: column !important;
        align-items: stretch !important;
        gap: 10px !important;
        width: 100% !important;
      }

      .bta-footer-main-row {
        display: flex !important;
        align-items: center !important;
        gap: 12px !important;
      }

      .bta-footer-price-display {
        font-size: 16px !important;
        font-weight: 700 !important;
        color: #B9582E !important;
        white-space: nowrap !important;
        display: none !important;
      }

      .bta-footer-price-display.is-visible {
        display: none !important;
      }

      .bta-footer-add-btn {
        background: #68876E !important;
        border: none !important;
        border-radius: 8px !important;
        color: #fff !important;
        cursor: pointer !important;
        font-size: 15px !important;
        font-weight: 700 !important;
        padding: 12px 32px !important;
        flex: 1 !important;
        letter-spacing: 0.03em !important;
        transition: background-color 0.2s !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }

      .bta-footer-add-btn:hover { background-color: #55715a !important; }

      .bta-footer-add-btn.is-disabled {
        background: #9bb09e !important;
        cursor: not-allowed !important;
        opacity: 0.7 !important;
        pointer-events: none !important;
      }

      .bta-footer-add-btn.is-success {
        background: #4a7a50 !important;
        pointer-events: none !important;
      }

      .bta-footer-add-btn.is-loading {
        pointer-events: none !important;
        opacity: 0.8 !important;
      }

      @keyframes bta-check-pop {
        0%   { transform: scale(0.6); opacity: 0; }
        60%  { transform: scale(1.2); opacity: 1; }
        100% { transform: scale(1);   opacity: 1; }
      }

      .bta-footer-add-btn .bta-btn-check-icon {
        display: none;
        animation: bta-check-pop 0.35s ease forwards;
      }

      .bta-footer-add-btn.is-success .bta-btn-label { display: none !important; }
      .bta-footer-add-btn.is-success .bta-btn-check-icon { display: inline-flex !important; }

      .bta-footer-skip-link {
        display: block !important;
        text-align: center !important;
        color: #B9582E !important;
        text-decoration: underline !important;
        text-underline-offset: 2px !important;
        font-size: 13px !important;
        cursor: pointer !important;
        background: none !important;
        border: none !important;
        font-family: inherit !important;
        padding: 4px 0 !important;
        width: 100% !important;
      }

      .bta-footer-skip-link:hover { color: #a34a24 !important; }

      .bta-decor-footer {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        padding: 12px 0 4px !important;
      }

      .bta-decor-price {
        font-size: 17px !important;
        font-weight: 700 !important;
        color: #fff !important;
        white-space: nowrap !important;
        text-align: center !important;
      }

      .bta-accordion-body__inner--decor {
        cursor: pointer !important;
      }

      .bta-product-addons-modal__addon-card.is-decor-selected {
        box-shadow: 0 0 0 3px #68876E !important;
        border-radius: 12px !important;
      }

      .bta-product-addons-modal__addon-card.is-decor-added {
        opacity: 0.55 !important;
        pointer-events: none !important;
      }

      @media (max-width: 600px) {
        .bta-product-addons-carousel { padding: 12px 12px 20px !important; }
        .bta-footer-add-btn { width: 100% !important; height: 44px !important; }
      }
    `;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    document.head.appendChild(style);
  }

  function transformCard(card, attempt) {
    attempt = attempt || 0;

    if (card.dataset.accordionDone) return;

    const prevWrapper = card.querySelector('[aria-hidden="true"]');
    if (prevWrapper) {
      const middleOld = prevWrapper.querySelector('.bta-card-middle-content');
      const bottomOld = prevWrapper.querySelector('.bta-card-bottom-content');
      if (middleOld || bottomOld) {
        card.innerHTML = '';
        if (middleOld) card.appendChild(middleOld);
        if (bottomOld) card.appendChild(bottomOld);
      }
    }

    const middleContent = card.querySelector('.bta-card-middle-content');
    const bottomContent = card.querySelector('.bta-card-bottom-content');

    if (!middleContent || !bottomContent) {
      if (attempt < 10) {
        setTimeout(() => transformCard(card, attempt + 1), 150);
      }
      return;
    }

    card.dataset.accordionDone = 'true';

    const currentCycle = (cardCycleIndex % 4) + 1;
    cardCycleIndex++;
    card.classList.remove('bta-color-cycle-1', 'bta-color-cycle-2', 'bta-color-cycle-3', 'bta-color-cycle-4');
    card.classList.add(`bta-color-cycle-${currentCycle}`);

    const titleEl = middleContent.querySelector('.bta-addon-title');
    const titleText = titleEl ? titleEl.textContent.trim() : 'Add-on';

    const header = document.createElement('div');
    header.className = 'bta-accordion-header';
    header.setAttribute('role', 'button');
    header.setAttribute('tabindex', '0');
    header.setAttribute('aria-expanded', 'false');
    header.innerHTML = `
      <span class="bta-accordion-header__title">${titleText}</span>
      <span class="bta-accordion-header__chevron"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6" style="width: 20px; height: 20px;">
          <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
        </svg></span>
    `;

    const body = document.createElement('div');
    body.className = 'bta-accordion-body';

    const inner = document.createElement('div');
    inner.className = 'bta-accordion-body__inner';

    const subtitle = document.createElement('p');
    subtitle.className = 'bta-accordion-subtitle';
    subtitle.textContent = 'Customize your celebration with extra playtime, more delicious bites, and magical details.';
    inner.appendChild(subtitle);

    const DECOR_TITLE = 'personalized deluxe decor';
    const DECOR_ITEMS = [
      'Personalized themed floor (144"x71")',
      '3 Side panels + cake',
      'Table + 3 cylinders',
      '8 themed centerpieces',
      'Balloon Installations',
      "Child's name + 4 printed characters",
      'Personalized table & desserts trays',
      'Party favors',
    ];
    const isDecorCard = titleText.toLowerCase().includes(DECOR_TITLE);

    if (isDecorCard) {
      card.dataset.isDecorCard = 'true';
      inner.classList.add('bta-accordion-body__inner--decor');

      const infoCarousel = document.createElement('div');
      infoCarousel.className = 'bta-variant-carousel';
      DECOR_ITEMS.forEach(item => {
        const infoSlide = document.createElement('div');
        infoSlide.className = 'bta-info-slide';
        infoSlide.textContent = item;
        infoCarousel.appendChild(infoSlide);
      });
      inner.appendChild(infoCarousel);

      // Price label (package — read from original addon price element)
      const decorPriceEl = bottomContent.querySelector('.bta-addon-price');
      const decorPriceText = decorPriceEl ? decorPriceEl.textContent.trim() : '';

      if (decorPriceText) {
        const decorFooter = document.createElement('div');
        decorFooter.className = 'bta-decor-footer';
        const decorPrice = document.createElement('span');
        decorPrice.className = 'bta-decor-price';
        decorPrice.textContent = decorPriceText;
        decorFooter.appendChild(decorPrice);
        inner.appendChild(decorFooter);
      }

      // Clicking anywhere in the body inner selects/deselects this package
      inner.addEventListener('click', () => {
        if (card.dataset.decorAdded) return;
        const isSelected = card.classList.contains('is-decor-selected');
        // Clear any variant slide selections from other cards
        document.querySelectorAll('.bta-slide-wrapper--selected').forEach(w => {
          w.classList.remove('bta-slide-wrapper--selected');
        });
        if (isSelected) {
          card.classList.remove('is-decor-selected');
          if (_btaCurrentSelectedCard === card) {
            _btaCurrentSelectedCard = null;
            _btaCurrentSelectedPrice = null;
            updateFooterState();
          }
        } else {
          card.classList.add('is-decor-selected');
          _btaCurrentSelectedCard = card;
          _btaCurrentSelectedPrice = decorPriceText || null;
          updateFooterState();
        }
        debugLog('Decor card toggled, selected:', !isSelected);
      });
    } else {
      const variantWrapper = middleContent.querySelector('.bta-variant-carousel-wrapper');
      if (variantWrapper) {
        variantWrapper.querySelectorAll('.bta-variant-nav').forEach(btn => btn.style.display = 'none');

        const carousel = variantWrapper.querySelector('.bta-variant-carousel');
        if (carousel) {
          carousel.querySelectorAll('.bta-variant-slide').forEach(slide => {
            const wrapper = document.createElement('div');
            wrapper.className = 'bta-slide-wrapper';
            slide.parentNode.insertBefore(wrapper, slide);
            wrapper.appendChild(slide);

            wrapper.addEventListener('click', () => {
              carousel.querySelectorAll('.bta-slide-wrapper').forEach(w => {
                w.classList.remove('bta-slide-wrapper--selected');
              });
              wrapper.classList.add('bta-slide-wrapper--selected');
              _btaCurrentSelectedCard = card;
              const variantPriceEl = slide.querySelector('.bta-variant-price');
              _btaCurrentSelectedPrice = variantPriceEl ? variantPriceEl.textContent.trim() : null;
              updateFooterState();
              slide.click();
            });
          });
        }

        inner.appendChild(variantWrapper);
      }
    }

    const priceEl = bottomContent.querySelector('.bta-addon-price');
    const errorContainer = bottomContent.querySelector('.bta-error-message-container');
    const quantitySection = bottomContent.querySelector('.bta-quantity-section');

    const cartRow = document.createElement('div');
    cartRow.className = 'bta-accordion-cart-row';
    if (priceEl) { priceEl.className = 'bta-accordion-price-label'; cartRow.appendChild(priceEl); }
    if (quantitySection) cartRow.appendChild(quantitySection);

    inner.appendChild(cartRow);
    if (errorContainer) inner.appendChild(errorContainer);

    body.appendChild(inner);

    card.innerHTML = '';
    card.appendChild(header);
    card.appendChild(body);

    const originalWrapper = document.createElement('div');
    originalWrapper.style.cssText = 'display:none!important;position:absolute;pointer-events:none;';
    originalWrapper.setAttribute('aria-hidden', 'true');
    originalWrapper.appendChild(middleContent);
    originalWrapper.appendChild(bottomContent);
    card.appendChild(originalWrapper);

    function openAccordion() {
      card.classList.add('is-selected-card');
      header.classList.add('is-open');
      header.setAttribute('aria-expanded', 'true');
      body.classList.add('is-open');
    }

    function closeAccordion() {
      card.classList.remove('is-selected-card');
      body.classList.remove('is-open');
      header.classList.remove('is-open');
      header.setAttribute('aria-expanded', 'false');
    }

    function toggle() {
      body.classList.contains('is-open') ? closeAccordion() : openAccordion();
    }

    header.addEventListener('click', toggle);
    header.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
    });

    sortCards();
  }

  function enableAddToCartButtons() {
    const buttons = document.querySelectorAll('.bta-add-to-cart-btn.disabled, .bta-add-to-cart-btn[disabled]');
    buttons.forEach(btn => {
      btn.classList.remove('disabled');
      btn.removeAttribute('disabled');
      debugLog('Enabled add-to-cart button:', btn);
    });
  }

  function watchAddToCartButtons() {
    if (window._btaAddToCartWatcherAdded) return;
    window._btaAddToCartWatcherAdded = true;

    const addToCartObserver = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes') {
          const target = mutation.target;
          if (
            target.classList?.contains('bta-add-to-cart-btn') &&
            (target.classList?.contains('disabled') || target.hasAttribute('disabled'))
          ) {
            setTimeout(() => {
              target.classList.remove('disabled');
              target.removeAttribute('disabled');
              debugLog('Re-enabled add-to-cart button after disable:', target);
            }, 100);
          }
        }

        if (mutation.type === 'childList' && mutation.addedNodes.length) {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) {
              const btns = node.querySelectorAll?.('.bta-add-to-cart-btn.disabled, .bta-add-to-cart-btn[disabled]');
              if (btns?.length) {
                setTimeout(enableAddToCartButtons, 100);
              }
            }
          });
        }
      }
    });

    addToCartObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'disabled'],
    });

    debugLog('Add-to-cart button watcher initialized');
  }

  function updateFooterState() {
    const footerAddBtn = document.querySelector('.bta-footer-add-btn');
    const footerPriceEl = document.querySelector('.bta-footer-price-display');

    // If a non-decor card is now selected, clear decor highlight
    if (!_btaCurrentSelectedCard?.dataset.isDecorCard) {
      document.querySelectorAll('.bta-product-addons-modal__addon-card.is-decor-selected').forEach(c => {
        c.classList.remove('is-decor-selected');
      });
    }

    if (footerAddBtn) {
      if (_btaCurrentSelectedCard) {
        footerAddBtn.classList.remove('is-disabled');
      } else {
        footerAddBtn.classList.add('is-disabled');
      }
    }

    if (footerPriceEl) {
      if (_btaCurrentSelectedPrice) {
        footerPriceEl.textContent = _btaCurrentSelectedPrice;
        footerPriceEl.classList.add('is-visible');
      } else {
        footerPriceEl.textContent = '';
        footerPriceEl.classList.remove('is-visible');
      }
    }

    debugLog('Footer state updated — card:', _btaCurrentSelectedCard, 'price:', _btaCurrentSelectedPrice);
  }

  function closeModal() {
    // Try triggering the original BTA continue button (hidden, but functional)
    const continueBtn = document.querySelector('.bta-product-addons-modal__continue');
    if (continueBtn) {
      continueBtn.style.removeProperty('display');
      continueBtn.click();
      continueBtn.style.setProperty('display', 'none', 'important');
      return;
    }
    // Fallback: remove modal--visible class
    const modal = document.querySelector('.bta-product-addons-modal');
    if (modal) modal.classList.remove('modal--visible');
  }

  function setupModalFooter() {
    const footer = document.querySelector('.bta-product-addons-modal__footer');
    if (!footer) return;

    // Reset selection state on each modal open
    _btaCurrentSelectedCard = null;
    _btaCurrentSelectedPrice = null;

    // Avoid duplicate setup
    if (footer.querySelector('.bta-footer-wrapper')) {
      updateFooterState();
      return;
    }

    const wrapper = document.createElement('div');
    wrapper.className = 'bta-footer-wrapper';

    const mainRow = document.createElement('div');
    mainRow.className = 'bta-footer-main-row';

    const priceDisplay = document.createElement('span');
    priceDisplay.className = 'bta-footer-price-display';

    const addBtn = document.createElement('button');
    addBtn.className = 'bta-footer-add-btn is-disabled';
    addBtn.type = 'button';
    addBtn.innerHTML = `
      <span class="bta-btn-label">Add to cart</span>
      <span class="bta-btn-check-icon">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" style="width:20px;height:20px;">
          <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
        </svg>
      </span>
    `;
    addBtn.addEventListener('click', () => {
      if (!_btaCurrentSelectedCard || addBtn.classList.contains('is-disabled')) return;
      const actualAddBtn = _btaCurrentSelectedCard.querySelector('.bta-add-to-cart-btn');
      if (!actualAddBtn) return;

      const cardBeingAdded = _btaCurrentSelectedCard;

      // Show loading state
      addBtn.classList.add('is-loading');
      actualAddBtn.click();
      debugLog('Footer add-to-cart triggered for card:', cardBeingAdded);

      // Show success animation after a short delay
      setTimeout(() => {
        addBtn.classList.remove('is-loading');
        addBtn.classList.add('is-success');

        // Reset after 1.8s — ready for next selection
        setTimeout(() => {
          addBtn.classList.remove('is-success');
          // If the decor package was added, lock it permanently (can only be added once)
          if (cardBeingAdded?.dataset.isDecorCard) {
            cardBeingAdded.dataset.decorAdded = 'true';
            cardBeingAdded.classList.remove('is-decor-selected');
            cardBeingAdded.classList.add('is-decor-added');
          }
          // Reset selection so user must pick again
          _btaCurrentSelectedCard = null;
          _btaCurrentSelectedPrice = null;
          // Clear slide selection highlights
          document.querySelectorAll('.bta-slide-wrapper--selected').forEach(w => {
            w.classList.remove('bta-slide-wrapper--selected');
          });
          updateFooterState();
        }, 1800);
      }, 400);
    });

    mainRow.appendChild(priceDisplay);
    mainRow.appendChild(addBtn);

    const skipLink = document.createElement('button');
    skipLink.className = 'bta-footer-skip-link';
    skipLink.type = 'button';
    skipLink.textContent = 'Skip for now';
    skipLink.addEventListener('click', () => {
      closeModal();
    });

    wrapper.appendChild(mainRow);
    wrapper.appendChild(skipLink);

    footer.insertBefore(wrapper, footer.firstChild);
    debugLog('Modal footer set up');
  }

  function applyScrollLayout() {
    const container = document.querySelector('.bta-product-addons-modal__container');
    const wrapper   = document.querySelector('.bta-product-addons-modal__content-wrapper');
    const carousel  = document.querySelector('.bta-product-addons-carousel-container');
    const hdr       = document.querySelector('.bta-product-addons-modal__header');
    const ftr       = document.querySelector('.bta-product-addons-modal__footer');

    if (!container || !wrapper) {
      debugLog('applyScrollLayout: container or wrapper not found');
      return;
    }

    const containerH = window.innerHeight - 40;

    const hdrH = hdr ? hdr.getBoundingClientRect().height : 0;
    const ftrH = ftr ? ftr.getBoundingClientRect().height : 0;
    const scrollH = containerH - hdrH - ftrH;

    const panel = ensureDebugPanel();
    if (panel) {
      const rectContainer = container.getBoundingClientRect();
      const rectWrapper = wrapper.getBoundingClientRect();
      const scrollInfo = [
        'BTA MODAL DEBUG',
        `viewportH: ${window.innerHeight}`,
        `containerH(css): ${containerH}`,
        `container(clientH): ${Math.round(container.clientHeight)}`,
        `container(rectH): ${Math.round(rectContainer.height)}`,
        `headerH: ${Math.round(hdrH)}`,
        `footerH: ${Math.round(ftrH)}`,
        `wrapperH(css): ${Math.round(scrollH)}`,
        `wrapper(clientH): ${Math.round(wrapper.clientHeight)}`,
        `wrapper(scrollH): ${Math.round(wrapper.scrollHeight)}`,
        `wrapper(overflow-y): ${getComputedStyle(wrapper).overflowY}`,
      ].join('\n');
      panel.textContent = scrollInfo;
    }

    debugLog('applyScrollLayout: ',
      {
        viewportH: window.innerHeight,
        containerH,
        headerH: hdrH,
        footerH: ftrH,
        scrollH,
        wrapperClientH: wrapper.clientHeight,
        wrapperScrollH: wrapper.scrollHeight,
        wrapperOverflowY: getComputedStyle(wrapper).overflowY,
      }
    );

    if (carousel) {
      carousel.style.setProperty('overflow-x', 'visible', 'important');
      carousel.style.setProperty('overflow-y', 'visible', 'important');
      carousel.style.removeProperty('overflow');
      carousel.style.setProperty('height', 'auto', 'important');
      carousel.style.setProperty('flex', 'none', 'important');
    }
  }

  function loadAllAddonPages() {
    const container = document.querySelector('.bta-product-addons-modal__container');
    if (!container) return;

    const nextBtn = container.querySelector('.bta-product-addons-carousel-container > .bta-carousel-nav--next');
    if (!nextBtn) return;

    let safety = 5;

    function clickNext() {
      if (!nextBtn.isConnected || safety-- <= 0) return;
      try {
        nextBtn.click();
      } catch (e) {
        debugLog('loadAllAddonPages click error', e);
        return;
      }
      setTimeout(clickNext, 700);
    }

    clickNext();
  }

  function watchStyleOverrides() {
    const targets = [
      document.querySelector('.bta-product-addons-modal__container'),
      document.querySelector('.bta-product-addons-modal__content-wrapper'),
    ].filter(Boolean);

    if (!targets.length || window._btaStyleWatcherAdded) return;
    window._btaStyleWatcherAdded = true;

    let applying = false;
    const styleWatcher = new MutationObserver(() => {
      if (applying) return;
      applying = true;
      applyScrollLayout();
      setTimeout(() => { applying = false; }, 0);
    });

    targets.forEach(el => {
      styleWatcher.observe(el, { attributes: true, attributeFilter: ['style'] });
    });
  }

  function forceScrollLayout() {
    const container = document.querySelector('.bta-product-addons-modal__container');
    if (!container) return;

    const isAnimating = getComputedStyle(container).opacity !== '1';

    if (isAnimating) {
      container.addEventListener('transitionend', function onEnd(e) {
        if (e.propertyName !== 'opacity' && e.propertyName !== 'transform') return;
        container.removeEventListener('transitionend', onEnd);
        applyScrollLayout();
        watchStyleOverrides();
      });
      setTimeout(() => { applyScrollLayout(); watchStyleOverrides(); }, 400);
    } else {
      applyScrollLayout();
      watchStyleOverrides();
    }

    if (!window._btaScrollListenerAdded) {
      window._btaScrollListenerAdded = true;
      window.addEventListener('resize', applyScrollLayout);
    }
  }

  function transformModal() {
    const cards = document.querySelectorAll('.bta-product-addons-modal__addon-card');
    if (!cards.length) return;
    injectStyles();
    cards.forEach(card => delete card.dataset.accordionDone);
    cards.forEach(card => {
      if (card.dataset.jsVariantChecked) transformCard(card);
    });
    forceScrollLayout();
    loadAllAddonPages();
    
    enableAddToCartButtons();
    watchAddToCartButtons();
    setupModalFooter();
    sortCards();

    const debugData = Array.from(cards).map(card => {
      const title = card.querySelector('.bta-accordion-header__title')?.textContent?.trim() || 'Sin título';
      const variants = card.querySelectorAll('.bta-variant-slide').length;
      return { title, variants };
    });
    debugLog('DOM addons summary:', debugData);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', transformModal);
  } else {
    transformModal();
  }

  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'data-js-variant-checked' &&
        mutation.target.classList?.contains('bta-product-addons-modal__addon-card')
      ) {
        injectStyles();
        delete mutation.target.dataset.accordionDone;
        transformCard(mutation.target);
      }

      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'class' &&
        mutation.target.classList?.contains('bta-product-addons-modal') &&
        mutation.target.classList?.contains('modal--visible')
      ) {
        transformModal();
        setTimeout(setupModalFooter, 200);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'data-js-variant-checked'],
  });

})();